import React from "react";

import CYCLING from "../assets/cycling.png";
import STACKING from "../assets/stacking.png";
import PYRAMIDING from "../assets/pyramiding.png";
import PLATEAUING from "../assets/plateauing.png";
import BLAST_AND_CRUISE from "../assets/blastandcruise.png";


const VerticalContentSection = (props) => {
  const [active, setActive] = React.useState(0);

  const handleOptionClick = (index) => {
    setActive(index);
  }

  const getAllOptions = () => {
    return props.data.map((item, index) => 
      <button className="content-option-vertical content-option-btn" key={`option${index}`} onClick={() => handleOptionClick(index)}>
        <p className="content-option-title">{item.title}</p>
      </button>
    );
  }

  const getExpandedBox = () => {
    if (active === -1) {
      return <></>;
    }

    return (
      <div className="content-option-popup">
        {props.data[active].description}
      </div>
    )
  }

  return (
    <div className="content-options-vertical-container">
      <div className="content-options-vertical">
        {getAllOptions()}
      </div>
      {getExpandedBox()}
    </div>
  );
}

const COMMON_PATTERNS = [
  {
    title: "Cycling",
    description: <div>
      <p>Cycling is when people take multiple doses for a period of time, stop for a time,
      then restart. This is the most common usage pattern, used by about half of guys taking testosterone.
      By taking breaks between cycles, guys increase the chance that they'll be able to resume
      testosterone production from their testes. Often, "PCT" or "post cycle therapy" is used at
      the end of each cycle to help kickstart this process.</p>
      <img className="pattern-graph" src={CYCLING}/>
    </div>
  },
  {
    title: "Stacking",
    description: <div>
      <p>Stacking is when people combine different steroids - for example, by mixing
      oral and/or injectable types, or using two types of injectables. Using multiple types of
      performance enhancing drugs at the same time is common to enhance effects, but comes with
      the risk of drug-drug interactions.</p>
      <img className="pattern-graph" src={STACKING}/>
    </div>
  },
  {
    title: "Pyramiding",
    description: <div>
      <p>Pyramiding is when people slowly increase either the dose or frequency of steroids.
      After they reach a peak amount, they gradually taper off.</p>
      <img className="pattern-graph" src={PYRAMIDING}/>
    </div>
  },
  {
    title: "Plateauing",
    description: <div>
      <p>Plateauing is when people alternate, overlap, or substitute with another steroid.
      This is done to avoid developing tolerance.</p>
      <img className="pattern-graph" src={PLATEAUING}/>
    </div>
  },
  {
    title: "Blast and Cruise",
    description: <div>
      <p>With blast and cruise, people start off at a high dose. Then, they decrease the dosage
      slightly and never stop. This comes with a high risk of becoming dependent on exogenous
      (outside) sources of testosterone indefinitely.</p>
      <img className="pattern-graph" src={BLAST_AND_CRUISE}/>
    </div>
  }
]


const CommonPatterns = () => {
  return (
    <section className="content-section">
      <h2>Common patterns of use</h2>
      <p>
        People use steroids in many different ways. Each method has different risks and benefits.
        Click each usage pattern to learn more.
      </p>
      <VerticalContentSection data={COMMON_PATTERNS}/>
    </section>
  );
}

export default CommonPatterns;